import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import Config from "Config";
import { isObject } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { animateScroll, scroller } from "react-scroll";
import { Constant } from "../../Constant";
import { send } from "../../SendRequest";
import {
    checkApplicant,
    fieldValueToFullJsonObj,
    generateV4UUID,
    getHasMultiSubmitLayer,
    getIsApproverSaveForm,
    getIsDownloadAttachmentForm,
    getIsMultiSubmitEmpty,
    getIsSubmitEditedButtionForm,
    getIspreviewPDFTooltipForm,
    getLangCode,
    isEmpty,
    isFunction,
    isNotEmpty,
    isObjectNotEmpty,
    parseIntFormRef,
} from "../../Utils";
import LoginDialog from "../../component/LoginDialog/LoginDialog";
import Mode from "../../constant/Mode";
import {
    getApproverEditFormTempRequest,
    setCurrentStep,
    setCurrentStepWithRerender,
    setFieldValues,
    setFullFieldValues,
    submitFormDone,
    toggleApproverEditLoadFormPopup,
    updateMultiSubmitEditing,
} from "../../redux/action";
import {
    getApproverEditFormTemp,
    getCurrentWorkFlow,
    getForm,
    getFormSubmittingData,
    getIsExceedingDeadline,
    getMultiSubmitEditing,
    getPopupStatus,
    getProfile,
    getSelectedUserOrg,
    getToken,
    getUserRole,
    getUserSCRN,
    getVersion,
} from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import ApprovalDialog from "../ApprovalDialog/ApprovalDialog";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import FormBox from "../FormBox/FormBox";
import SigningDialog from "../SigningDialog/SigningDialog";
import Form007SubmittedDialog from "../SubmittedDialog/Form007SubmittedDialog";
import Form016SubmittedDialog from "../SubmittedDialog/Form016SubmittedDialog";
import Form017SubmittedDialog from "../SubmittedDialog/Form017SubmittedDialog";
import Form028SubmittedDialog from "../SubmittedDialog/Form028SubmittedDialog";
import Form029SubmittedDialog from "../SubmittedDialog/Form029SubmittedDialog";
import Form040SubmittedDialog from "../SubmittedDialog/Form040SubmittedDialog";
import Form045SubmittedDialog from "../SubmittedDialog/Form045SubmittedDialog";
import Form059SubmittedDialog from "../SubmittedDialog/Form059SubmittedDialog";
import Form075SubmittedDialog from "../SubmittedDialog/Form075SubmittedDialog";
import Form091SubmittedDialog from "../SubmittedDialog/Form091SubmittedDialog";
import Form098EditDialog from "../SubmittedDialog/Form098EditDialog";
import Form101EditDialog from "../SubmittedDialog/Form101EditDialog";
import Form101SubmittedDialog from "../SubmittedDialog/Form101SubmittedDialog";
import Form101SubmittedTimeOutDialog from "../SubmittedDialog/Form101SubmittedTimeOutDialog";
import Form102EditDialog from "../SubmittedDialog/Form102EditDialog";
import Form102SubmittedDialog from "../SubmittedDialog/Form102SubmittedDialog";
import Form106SubmittedDialog from "../SubmittedDialog/Form106SubmittedDialog";
import Form107SubmittedDialog from "../SubmittedDialog/Form107SubmittedDialog";
import SubmittedDialog from "../SubmittedDialog/SubmittedDialog";
import WithdrawnDialog from "../WithdrawnDialog/WithdrawnDialog";
import SubFileSelectDialog from "../subFileSelectDialog/SubFileSelectDialog";
import "./StepBar.scss";

const useStyles = makeStyles((theme) => ({
    submitBtn: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: 0,
        boxShadow: "none",
        marginLeft: "8px",
        "&:hover": {
            backgroundColor: theme.palette.primary.dim,
        },
    },
    backBtn: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.common.black,
        borderRadius: 0,
        boxShadow: "none",
        marginLeft: "8px",
        "&:hover": {
            backgroundColor: theme.palette.secondary.dim,
            color: theme.palette.common.white,
        },
    },
}));

export default function StepBar({
    onBack,
    onClear,
    onNext,
    onSubmit = () => {},
    disableSave = false,
    finalSubmitStep = false,
    requiredLogin = false,
    clearErrors = () => {},
    //save function
    handleSubmit,
    onError,
    skipMultiSubmit = [],
    isApplicantSigning = false,
    disablePDF = false,
    skipReject = false,
    skipReturn = false,
    checkApproverRole,
    approvalSubmitText,
    approvalSignText,
    currentPageFileIds = [],
    pageNum,
}) {
    let winRef = null;

    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [validMsg, setValidMsg] = useState("");

    const {
        formId,
        mode,
        status,
        params,
        fieldValues,
        currentStep,
        initialStep,
        referenceId,
        replySlipOption,
        formEnterLocalTime,
        applicantCanWithdrawal,
        secondApproverNeedSign,
    } = useSelector(getForm());
    const {
        approverEditCurrentStep,
        approverEditFieldValues,
        approverEditFormLanguage,
    } = useSelector(getApproverEditFormTemp());
    const token = useSelector(getToken());
    const formRef = parseIntFormRef(referenceId);
    const approverEditLoadForm = useSelector(
        getPopupStatus("approverEditLoadForm")
    );
    const isFormFilling = mode === Mode.formFilling;
    const isEdbEditing = mode === Mode.edbEditing;
    const isEdbApproval = mode === Mode.edbApproval;
    const isEditing =
        mode === Mode.editing || isEdbEditing || applicantCanWithdrawal;
    const isSigning = mode === Mode.signing;
    const isSavedDraft = mode === Mode.savedDraft;
    const isApprovalStep = currentStep == "Approval";
    const hasBackButton = ["Approval", initialStep].indexOf(currentStep) < 0;
    const hasEditButton = (isEditing || isFormFilling) && isApprovalStep;
    const hasExitEditButton =
        !isApprovalStep && isNotEmpty(initialStep) && !isSavedDraft;
    const hasSubmitEditButton = isEditing && currentStep == "Confirmation";
    const hasApproveButton =
        isEditing && isApprovalStep && applicantCanWithdrawal !== true;
    const hasReturnButton =
        mode !== Mode.readOnly && status >= 1 && isApprovalStep;
    const layer =
        status == 3 || status == 4
            ? "2"
            : status == 5 || status == 6
            ? "3"
            : status == 7 || status == 8
            ? "4"
            : "";

    const formSubmittingData = useSelector(getFormSubmittingData());
    const [exitEditPopup, setExitEditPopup] = useState(false);
    const [savePopup, setSavePopup] = useState(false);
    const [saveBeforeDownloadSuccessPopup, setSaveBeforeDownloadSuccessPopup] =
        useState(false);
    const [saveSuccessPopup, setSaveSuccessPopup] = useState(false);
    const [backPopup, setBackPopup] = useState(false);
    const [saveFailPopup, setSaveFailPopup] = useState(false);
    const [validFailPopup, setValidFailPopup] = useState(false);
    const [approverSavePopup, setApproverSavePopup] = useState(false);
    const [approverSaveSuccessPopup, setApproverSaveSuccessPopup] =
        useState(false);
    const [approverSaveFailPopup, setApproverSaveFailPopup] = useState(false);
    const [open, setOpen] = useState(false);
    const [openSubmittedDialog, setOpenSubmittedDialog] = useState(false);
    const [form016OpenSubmittedDialog, setForm016OpenSubmittedDialog] =
        useState(false);
    const [form017OpenSubmittedDialog, setForm017OpenSubmittedDialog] =
        useState(false);
    const [form028OpenSubmittedDialog, setForm028OpenSubmittedDialog] =
        useState(false);
    const [form045OpenSubmittedDialog, setForm045OpenSubmittedDialog] =
        useState(false);
    const [form075OpenSubmittedDialog, setForm075OpenSubmittedDialog] =
        useState(false);
    const [form029OpenSubmittedDialog, setForm029OpenSubmittedDialog] =
        useState(false);
    const [form040OpenSubmittedDialog, setForm040OpenSubmittedDialog] =
        useState(false);
    const [form101SubmittedTimeOutDialog, setForm101SubmittedTimeOutDialog] =
        useState(false);
    const [form101OpenEditDialog, setForm101OpenEditDialog] = useState(false);
    const [form101OpenSubmittedDialog, setForm101OpenSubmittedDialog] =
        useState(false);
    const [form059OpenSubmittedDialog, setForm059OpenSubmittedDialog] =
        useState(false);
    const [form091OpenSubmittedDialog, setForm091OpenSubmittedDialog] =
        useState(false);
    const [form102OpenSubmittedDialog, setForm102OpenSubmittedDialog] =
        useState(false);
    const [form106OpenSubmittedDialog, setForm106OpenSubmittedDialog] =
        useState(false);
    const [form098OpenEditDialog, setForm098OpenEditDialog] = useState(false);
    const [form102EditDialog, setForm102EditDialog] = useState(false);
    const [form007OpenSubmittedDialog, setForm007OpenSubmittedDialog] =
        useState(false);
    const [form107OpenSubmittedDialog, setForm107OpenSubmittedDialog] =
        useState(false);
    const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
    const [openLogin, setOpenLogin] = useState(false);
    const [action, setAction] = useState("");
    const [subFilePopup, setSubFilePopup] = useState(false);
    const [multiSubmitPopup, setMultiSubmitPopup] = useState(false);
    const [approveRolePopup, setApproveRolePopup] = useState(false);
    const [openWithdrawnDialog, setOpenWithdrawnDialog] = useState(false);

    const hasMultiSubmitLayer = getHasMultiSubmitLayer(
        formId,
        status,
        skipMultiSubmit
    );

    const version = useSelector(getVersion());
    const isExceedingDeadline = useSelector(getIsExceedingDeadline());
    const scrn = useSelector(getUserSCRN());
    const userRole = useSelector(getUserRole());
    const isMultiSubmitEditing = useSelector(getMultiSubmitEditing());
    const currentWorkFlow = useSelector(getCurrentWorkFlow());
    const profile = useSelector(getProfile());
    const uesrOrg = useSelector(getSelectedUserOrg());

    // is change SubmitEdited Button
    const isSubmitEditedButton = getIsSubmitEditedButtionForm(formId);
    const isDownloadAttachmentButton = getIsDownloadAttachmentForm(formId);
    // const isThirdApprover = checkThirdApprover(currentWorkFlow, profile);
    // const isFourthApprover = checkFourthApprover(currentWorkFlow, profile);
    const form98UseCase =
        formId === "Form098" &&
        (status === 6 || status === 7 || status === 8 || status === 20);
    //  && (isThirdApprover || isFourthApprover);
    const form98SecApprover =
        formId === "Form098" && (status == 3 || status == 4);

    const form102EDBReviewerReceive =
        formId === "Form102" && status == 4 && isSigning;

    const form102EDBReviewerApprove =
        formId === "Form102" && status == 10 && isEdbApproval;
    const deadLine = isNotEmpty(params?.deadLine)
        ? moment(params?.deadLine, [
              "YYYY-MM-DD",
              "DD/MM/YYYY",
              "YYYY年MM月DD日",
          ]).diff(moment(), "days") < 0
        : false;

    const form090ExceedingDeadline = formId === "Form090" && deadLine;
    const handleExitClose = () => {
        setExitEditPopup(false);
    };
    const handleExitConfirm = () => {
        setExitEditPopup(false);
        // dispatch(setCurrentStep("Approval"));
        window.location.reload();
    };
    const handleSaveClose = () => {
        setSavePopup(false);
    };
    const handleSaveConfirm = () => {
        setSavePopup(false);
        if (finalSubmitStep) {
            onSaveConfirm({});
        } else {
            handleSubmit(onSaveConfirm, (errors) => {
                setSaveFailPopup(true);
                onError(errors);
            })();
        }
    };
    const handleSaveNoRedirect = () => {
        setSavePopup(false);
        if (finalSubmitStep) {
            onSaveNoRedirect({});
        } else {
            handleSubmit(onSaveNoRedirect, (errors) => {
                setSaveFailPopup(true);
                onError(errors);
            })();
        }
    };
    const handleApproverSaveClose = () => {
        setApproverSavePopup(false);
    };
    const handleApproverSaveConfirm = () => {
        setApproverSavePopup(false);
        if (finalSubmitStep) {
            onApproverSaveConfirm({});
        } else {
            handleSubmit(onApproverSaveConfirm, (errors) => {
                setApproverSaveFailPopup(true);
                onError(errors);
            })();
        }
    };
    const handleApproverSaveNoRedirect = () => {
        setApproverSavePopup(false);
        if (finalSubmitStep) {
            onApproverSaveNoRedirect({});
        } else {
            handleSubmit(onApproverSaveNoRedirect, (errors) => {
                setApproverSaveFailPopup(true);
                onError(errors);
            })();
        }
    };
    const handleNextAction = (formData) => {
        if (requiredLogin && isEmpty(token)) {
            setOpenLogin(true);
        } else {
            onNext(formData);
            scrollToError();
        }
    };
    const handleErrorAction = (errors, isLogin) => {
        if (isLogin && isNotEmpty(clearErrors)) {
            clearErrors();
            return false;
        }
        onError(errors);
        scrollToError();
    };
    const handleMultiSubmitClose = () => {
        setMultiSubmitPopup(false);
    };

    const onSaveConfirm = (formData) => {
        if (formId === "Form101" && currentStep === "Post") {
            formData.job = formData?.job
                ?.filter?.((job) => job?.checked)
                ?.map((job) => {
                    return {
                        jobTitle: job?.jobTitle,
                        subjectList: job?.subjectList
                            ?.filter?.((subject) => subject?.checked)
                            ?.map((subject) => subject?.subjectName),
                    };
                });
        }
        if (formId === "Form105" && currentStep === "PartA") {
            formData.uploadFiles = formData?.uploadFiles?.map(
                (files) => files?.file?.[0]
            );
        }
        // Capture original uploadFiles (nested [{ file: [obj] }] format) before flattening,
        // so it can be merged into fullJsonObj for correct round-trip on load
        const form107OriginalUploadFiles =
            formId === "Form107" && currentStep === "PartA" ? formData?.uploadFiles : undefined;
        if (formId === "Form107" && currentStep === "PartA") {
            formData.uploadFiles = formData?.uploadFiles?.map(
                (files) => files?.file?.[0]
            );
        }
        // Form107 uses saveDraft API (formal data, same params as submit)
        if (formId === "Form107") {
            const mergedFieldValuesFor107 = { ...fieldValues };
            if (form107OriginalUploadFiles) {
                mergedFieldValuesFor107[currentStep] = {
                    ...formData,
                    uploadFiles: form107OriginalUploadFiles,
                };
            } else {
                mergedFieldValuesFor107[currentStep] = formData;
            }
            let dataJson = {
                formRef: formRef,
                formLanguage: getLangCode(i18n.language),
                fullJsonObj: JSON.stringify(fieldValueToFullJsonObj(mergedFieldValuesFor107)),
                params: params,
                version: version,
                scrn: scrn,
                ...formSubmittingData,
                ...formData,
            };
            const dataString = JSON.stringify(dataJson);
            const option = {
                url: `${Config.CONTENT_PATH}/form107/saveDraft`,
                method: "POST",
                body: dataString,
                option: { dataType: "json" },
            };
            dispatch(send("SUBMIT_FORM_TEMP", option))
                .then((res) => res.json())
                .then((jsonObj) => {
                    if (isObjectNotEmpty(jsonObj)) {
                        if (isNotEmpty(jsonObj?.id)) {
                           setSaveSuccessPopup(true);
                        }
                    } else {
                        setSaveFailPopup(true);
                    }
                });
            return;
        }
        const dataJson = {
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(
                fieldValueToFullJsonObj(
                    { ...fieldValues, [currentStep]: formData },
                    currentStep
                )
            ),
            scrn: scrn,
            ...formSubmittingData,
            ...formData,
        };
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}Temp/save`,
            method: "POST",
            body: dataString,
            option: { dataType: "json" },
        };
        dispatch(send("SUBMIT_FORM_TEMP", option))
            .then((res) => res.json())
            .then((jsonObj) => {
                if (isObjectNotEmpty(jsonObj)) {
                    setSaveSuccessPopup(true);
                } else {
                    setSaveFailPopup(true);
                }
            });
    };

    const onSaveNoRedirect = (formData) => {
        if (formId === "Form101" && currentStep === "Post") {
            formData.job = formData?.job
                ?.filter?.((job) => job?.checked)
                ?.map((job) => {
                    return {
                        jobTitle: job?.jobTitle,
                        subjectList: job?.subjectList
                            ?.filter?.((subject) => subject?.checked)
                            ?.map((subject) => subject?.subjectName),
                    };
                });
        }
        if (formId === "Form105" && currentStep === "PartA") {
            formData.uploadFiles = formData?.uploadFiles?.map(
                (files) => files?.file?.[0]
            );
        }
        // Capture original uploadFiles (nested [{ file: [obj] }] format) before flattening,
        // so it can be merged into fullJsonObj for correct round-trip on load
        const form107OriginalUploadFiles =
            formId === "Form107" && currentStep === "PartA" ? formData?.uploadFiles : undefined;
        if (formId === "Form107" && currentStep === "PartA") {
            formData.uploadFiles = formData?.uploadFiles?.map(
                (files) => files?.file?.[0]
            );
        }
        // Form107 uses saveDraft API (formal data, same params as submit)
        if (formId === "Form107") {
            const mergedFieldValuesFor107 = { ...fieldValues };
            if (form107OriginalUploadFiles) {
                mergedFieldValuesFor107[currentStep] = {
                    ...formData,
                    uploadFiles: form107OriginalUploadFiles,
                };
            } else {
                mergedFieldValuesFor107[currentStep] = formData;
            }
            let dataJson = {
                formRef: formRef,
                formLanguage: getLangCode(i18n.language),
                fullJsonObj: JSON.stringify(fieldValueToFullJsonObj(mergedFieldValuesFor107)),
                params: params,
                version: version,
                scrn: scrn,
                ...formSubmittingData,
                ...formData,
            };
            const dataString = JSON.stringify(dataJson);
            const option = {
                url: `${Config.CONTENT_PATH}/form107/saveDraft`,
                method: "POST",
                body: dataString,
                option: { dataType: "json" },
            };
            dispatch(send("SUBMIT_FORM_TEMP", option))
                .then((res) => res.json())
                .then((jsonObj) => {
                    if (isObjectNotEmpty(jsonObj)) {
                        if (isNotEmpty(jsonObj?.id)) {
                             const refNum = `Form107${String(jsonObj.id).padStart(6, "0")}`;
                            dispatch({
                                type: Constant.action.SAVE_FORM107_DRAFT,
                                payload: refNum,
                            });
                            navigate(`/draft/Form107/${refNum}`);
                        }
                    }
                });
            return;
        }
        const dataJson = {
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(
                fieldValueToFullJsonObj(
                    { ...fieldValues, [currentStep]: formData },
                    currentStep
                )
            ),
            scrn: scrn,
            ...formSubmittingData,
            ...formData,
        };
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}Temp/save`,
            method: "POST",
            body: dataString,
            option: { dataType: "json" },
        };
        dispatch(send("SUBMIT_FORM_TEMP", option));
        dispatch(setFieldValues(currentStep, formData));
    };
    const onApproverSaveConfirm = (formData) => {
        const dataJson = {
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(
                fieldValueToFullJsonObj(
                    { ...fieldValues, [currentStep]: formData },
                    currentStep
                )
            ),
            formRef,
            // scrn: scrn,
            ...formSubmittingData,
            ...formData,
        };
        if (getIsApproverSaveForm(formId)) {
            dataJson.saveType = isMultiSubmitEditing ? "2" : "1";
        }
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}Temp/${
                isEdbEditing ? "reviewerEdit" : `saveTempEdit${layer}`
            }`,
            method: "PUT",
            body: dataString,
            option: { dataType: "json" },
        };
        dispatch(send("APPROVER_EDIT_FORM_TEMP", option))
            .then((res) => res.json())
            .then((jsonObj) => {
                if (isObjectNotEmpty(jsonObj)) {
                    setSaveSuccessPopup(true);
                } else {
                    setSaveFailPopup(true);
                }
            });
    };

    const onApproverSaveNoRedirect = (formData) => {
        const dataJson = {
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(
                fieldValueToFullJsonObj(
                    { ...fieldValues, [currentStep]: formData },
                    currentStep
                )
            ),
            formRef,
            // scrn: scrn,
            ...formSubmittingData,
            ...formData,
        };
        if (getIsApproverSaveForm(formId)) {
            dataJson.saveType = isMultiSubmitEditing ? "2" : "1";
        }
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}Temp/${
                isEdbEditing ? "reviewerEdit" : `saveTempEdit${layer}`
            }`,
            method: "PUT",
            body: dataString,
            option: { dataType: "json" },
        };
        dispatch(send("APPROVER_EDIT_FORM_TEMP", option));
    };

    const onFormSubmit = async () => {
        onSubmit();
        if (formId === "Form101") {
            const submitLocalTime = moment(new Date());
            if (
                submitLocalTime.diff(moment(formEnterLocalTime), "hours") >= 2
            ) {
                setForm101SubmittedTimeOutDialog(true);
                return false;
            }
        }
        let dataJson = {
            formRef: formRef,
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(fieldValueToFullJsonObj(fieldValues)),
            params: params,
            version: version,
            scrn: scrn,
            ...formSubmittingData,
        };
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/${
                applicantCanWithdrawal === true ? "applicantEdit" : "submit"
            }`,
            method: "POST",
            body: dataString,
            option: { dataType: "json" },
            header: {
                "X-Request-ID": generateV4UUID(),
            },
        };
        return dispatch(send("SUBMIT_FORM", option))
            .then((res) => res.json())
            .then((data) => {
                if (
                    data?.code === "9110" ||
                    data?.code === "9111" ||
                    data?.code === "9112" ||
                    data?.code === "9113" ||
                    data?.code === "9114" ||
                    data?.code === "9115" ||
                    data?.code === "9116" ||
                    data?.code === "9117" ||
                    data?.code === "9118" ||
                    data?.code === "9119" ||
                    data?.code === "9120" ||
                    data?.code === "9121"
                ) {
                    setValidMsg(t(`errorMsg.validData.${data?.code}`));
                    setValidFailPopup(true);
                }

                if (isNotEmpty(data?.referenceNumber)) {
                    dispatch(submitFormDone(formId, data));
                    if (formId === "Form017") {
                        setForm017OpenSubmittedDialog(true);
                    } else if (formId === "Form016") {
                        setForm016OpenSubmittedDialog(true);
                    } else if (formId === "Form028") {
                        setForm028OpenSubmittedDialog(true);
                    } else if (formId === "Form045") {
                        setForm045OpenSubmittedDialog(true);
                    } else if (formId === "Form075") {
                        setForm075OpenSubmittedDialog(true);
                    } else if (formId === "Form029") {
                        setForm029OpenSubmittedDialog(true);
                    } else if (formId === "Form040") {
                        setForm040OpenSubmittedDialog(true);
                    } else if (formId === "Form091") {
                        setForm091OpenSubmittedDialog(true);
                    } else if (formId === "Form101") {
                        setForm101OpenSubmittedDialog(true);
                    } else if (formId === "Form102") {
                        setForm102OpenSubmittedDialog(true);
                    } else if (formId === "Form106") {
                        setForm106OpenSubmittedDialog(true);
                    } else if (formId === "Form107") {
                        setForm107OpenSubmittedDialog(true);
                    } else {
                        setOpenSubmittedDialog(true);
                    }
                } else {
                    data.referenceNumber = referenceId;
                }
                return data;
            });
    };

    // const signNull = () => {
    //     const formData = new FormData();
    //     formData.append("formRef", formRef);
    //     formData.append("sign", "N");
    //     const option = {
    //         url: "sdfsdf",
    //         method: "POST",
    //         body: formData,
    //     };
    //     return dispatch(send("SIGN_NULL", option)).catch((error) =>
    //         console.log("sign null error: ", error)
    //     );
    // };

    const onFormEdit = () => {
        let dataJson = {
            formRef: formRef,
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(fieldValueToFullJsonObj(fieldValues)),
            params: params,
            version: version,
            ...formSubmittingData,
        };
        const dataString = JSON.stringify(dataJson);
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/${
                applicantCanWithdrawal === true
                    ? "applicantEdit"
                    : isEdbEditing
                    ? "reviewerEdit"
                    : `edit${layer}`
            }`,
            method: applicantCanWithdrawal === true ? "POST" : "PUT",
            body: dataString,
        };
        dispatch(send("APPROVAL_FLOW", option))
            .then((res) => res.json())
            .then((data) => {
                // console.log(res.json());
                const afterStatus = data.status;
                if (
                    formId === "Form098" &&
                    ((status === 1 && afterStatus === 1) ||
                        (status === 7 && afterStatus === 7))
                ) {
                    setForm098OpenEditDialog(true);
                } else if (formId === "Form101") {
                    setForm101OpenEditDialog(true);
                } else {
                    window.location.reload();
                }
            });
    };
    const onFormApproval = async ({
        msg = "",
        act = "",
        workflowRole = [],
        signKeyType = "",
        signData = {},
    }) => {
        if (
            act.includes("approve") &&
            !(formId === "Form102" && status === 4)
        ) {
            const formData = new FormData();
            formData.append("type", signKeyType);
            console.log("type signData: ", signKeyType);
            if (signKeyType === "I") {
                formData.append("iamsmartOriginal", signData?.cert);
                formData.append("iamsmartSigned", signData?.signature);
                formData.append("iamsmartHashcode", signData?.hashCode);
                console.log("Appending IAMSmart signature data");
            } else if (signKeyType === "U") {
                formData.append("upload", signData);
            } else if (signKeyType === "D") {
                formData.append("digitalSigning", signData);
            }
            formData?.append("status", status);
            formData?.append("formRef", formRef);
            formData?.append("msg", msg);

            act = act?.replace("approve", "updateSigningAndApprove");
            const option = {
                url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/${act}`,
                method: "PUT",
                body: formData,
                header: {
                    "X-Request-ID": generateV4UUID(),
                },
            };
            console.log("onFormApproval formData: ", formData);
            return await dispatch(send("APPROVAL_FLOW", option)).then((res) => {
                window.location.reload();
                return res.json();
            });
        } else {
            const formData = new FormData();
            formData.append("formRef", formRef);
            formData.append("msg", msg);
            if (formId === "Form104" && action === "return") {
                formData.append(
                    "principalOrSupervisorList",
                    workflowRole.join(",")
                );
            }
            const link = isEmpty(act) ? action : act;
            const option = {
                url:
                    formId === "Form104" && action === "return"
                        ? `${
                              Config.CONTENT_PATH
                          }/${formId.toLowerCase()}/returnForm104`
                        : `${
                              Config.CONTENT_PATH
                          }/${formId.toLowerCase()}/${link}`,
                method: "PUT",
                body: formData,
                header: {
                    "X-Request-ID": generateV4UUID(),
                },
            };
            return await dispatch(send("APPROVAL_FLOW", option)).then((res) => {
                return res.json().then((data) => {
                    if (formId === "Form107" && act === "review" && data?.code === "9203") {
                        setValidMsg(t("errorMsg.validData.9203", {
                            defaultValue: "There are files that have not been virus scanned or are infected with virus.",
                        }));
                        setValidFailPopup(true);
                        return data;
                    }
                    window.location.reload();
                    return data;
                });
            });
        }
    };
    const onSign = (signKeyType, signData) => {
        console.log("onSign signData: ", signData);
        if (isSigning) {
            return onFormApproval({
                act: `approve${layer}`,
                signKeyType,
                signData,
            });
        } else {
            return onFormSubmitWithSignature(signKeyType, signData);
        }
    };

    const onFormSubmitWithSignature = async (signKeyType, signData) => {
        onSubmit();
        if (formId === "Form101") {
            const submitLocalTime = moment(new Date());
            if (
                submitLocalTime.diff(moment(formEnterLocalTime), "hours") >= 2
            ) {
                setForm101SubmittedTimeOutDialog(true);
                return false;
            }
        }

        // 构造表单数据
        let dataJson = {
            formRef: formRef,
            formLanguage: getLangCode(i18n.language),
            fullJsonObj: JSON.stringify(fieldValueToFullJsonObj(fieldValues)),
            params: params,
            version: version,
            scrn: scrn,
            ...formSubmittingData,
        };

        // 创建FormData对象用于multipart/form-data请求
        const formData = new FormData();
        formData.append(
            "request",
            new Blob([JSON.stringify(dataJson)], {
                type: "application/json",
            })
        );

        // 添加签名相关参数
        formData.append("type", signKeyType); // 签名类型

        // 根据不同的签名方式添加相应的签名数据
        if (signKeyType === "I") {
            // IAMSmart签名
            formData.append("iamsmartOriginal", signData?.cert);
            formData.append("iamsmartSigned", signData?.signature);
            formData.append("iamsmartHashcode", signData?.hashCode);
        } else if (signKeyType === "U") {
            // 上传签名
            formData.append("upload", signData);
        } else if (signKeyType === "D") {
            // 数字签名
            formData.append("digitalSigning", signData);
        }

        // 根据applicantCanWithdrawal的值决定调用哪个API
        let apiUrl, actionType;
        if (applicantCanWithdrawal === true) {
            // 使用applicantEditAndSigning API
            apiUrl = `${
                Config.CONTENT_PATH
            }/${formId.toLowerCase()}/applicantEditAndSigning`;
            actionType = "APPLICANT_EDIT_AND_SIGNING";
        } else {
            // 使用submitFormAndSigning API
            apiUrl = `${
                Config.CONTENT_PATH
            }/${formId.toLowerCase()}/submitFormAndSigning`;
            actionType = "SUBMIT_FORM_AND_SIGNING";
        }

        const option = {
            url: apiUrl,
            method: "POST",
            body: formData,
            header: {
                "X-Request-ID": generateV4UUID(),
            },
        };

        return dispatch(send("SUBMIT_FORM", option))
            .then((res) => res.json())
            .then((data) => {
                if (
                    data?.code === "9110" ||
                    data?.code === "9111" ||
                    data?.code === "9112" ||
                    data?.code === "9113" ||
                    data?.code === "9114" ||
                    data?.code === "9115" ||
                    data?.code === "9116" ||
                    data?.code === "9117" ||
                    data?.code === "9118" ||
                    data?.code === "9119" ||
                    data?.code === "9120" ||
                    data?.code === "9121"
                ) {
                    setValidMsg(t(`errorMsg.validData.${data?.code}`));
                    setValidFailPopup(true);
                }
                data = applicantCanWithdrawal ? data.data : data;
                if (isNotEmpty(data?.referenceNumber)) {
                    dispatch(submitFormDone(formId, data));
                    if (formId === "Form017") {
                        setForm017OpenSubmittedDialog(true);
                    } else if (formId === "Form016") {
                        setForm016OpenSubmittedDialog(true);
                    } else if (formId === "Form028") {
                        setForm028OpenSubmittedDialog(true);
                    } else if (formId === "Form045") {
                        setForm045OpenSubmittedDialog(true);
                    } else if (formId === "Form075") {
                        setForm075OpenSubmittedDialog(true);
                    } else if (formId === "Form029") {
                        setForm029OpenSubmittedDialog(true);
                    } else if (formId === "Form040") {
                        setForm040OpenSubmittedDialog(true);
                    } else if (formId === "Form091") {
                        setForm091OpenSubmittedDialog(true);
                    } else if (formId === "Form102") {
                        setForm102OpenSubmittedDialog(true);
                    } else if (formId === "Form101") {
                        setForm101OpenSubmittedDialog(true);
                    } else if (formId === "Form106") {
                        setForm106OpenSubmittedDialog(true);
                    } else if (formId === "Form107") {
                        setForm107OpenSubmittedDialog(true);
                    } else {
                        setOpenSubmittedDialog(true);
                    }
                } else {
                    data.referenceNumber = referenceId;
                }
                return data;
            });
    };
    const onDownload = (subDoc = "") => {
        const option = {
            url: isEmpty(subDoc)
                ? `${
                      Config.CONTENT_PATH
                  }/${formId.toLowerCase()}/report/${formRef}`
                : `${
                      Config.CONTENT_PATH
                  }/${formId.toLowerCase()}/report/${formRef}/${subDoc}`,
            header: { Accept: "application/pdf" },
        };

        const isIOS =
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isInAppBrowser = navigator.userAgent.includes(
            "iAM Smart In-App Browser"
        );

        if (isIOS || isInAppBrowser) {
            // iOS Safari and In-App Browser: pass backend API URL directly
            // viewer.html will fetch with token from cookie
            const pdfApiUrl = isEmpty(subDoc)
                ? `${
                      Config.CONTENT_PATH
                  }/${formId.toLowerCase()}/report/${formRef}`
                : `${
                      Config.CONTENT_PATH
                  }/${formId.toLowerCase()}/report/${formRef}/${subDoc}`;

            window.location.href = `${
                Config.CONTENT_PATH
            }/pdf/viewer.html?file=${encodeURIComponent(pdfApiUrl)}`;
        } else {
            // Non-iOS and non-In-App Browser: use original logic (fetch blob first)
            dispatch(send("GET_REPORT", option))
                .then((res) => res.blob())
                .then((data) => {
                    const blobUrl = URL.createObjectURL(data);
                    winRef = window.open(
                        `${
                            Config.CONTENT_PATH
                        }/pdf/viewer.html?file=${encodeURIComponent(blobUrl)}`,
                        "_blank"
                    );
                })
                .catch((error) => {
                    console.error("Failed to load PDF:", error);
                });
        }
    };

    const onDownloadPDFBeforeSave = (subDoc = "") => {
        const option = {
            url: `${
                Config.CONTENT_PATH
            }/${formId.toLowerCase()}Temp/tempReport`,

            header: { Accept: "application/pdf" },
        };

        const isIOS =
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isInAppBrowser = navigator.userAgent.includes(
            "iAM Smart In-App Browser"
        );

        if (isIOS || isInAppBrowser) {
            // iOS Safari and In-App Browser: pass backend API URL directly
            // viewer.html will fetch with token from cookie
            const pdfApiUrl = `${
                Config.CONTENT_PATH
            }/${formId.toLowerCase()}Temp/tempReport`;

            window.location.href = `${
                Config.CONTENT_PATH
            }/pdf/viewer.html?file=${encodeURIComponent(pdfApiUrl)}`;
        } else {
            // Non-iOS and non-In-App Browser: use original logic (fetch blob first)
            dispatch(send("GET_REPORT", option))
                .then((res) => res.blob())
                .then((data) => {
                    const blobUrl = URL.createObjectURL(data);
                    winRef = window.open(
                        `${
                            Config.CONTENT_PATH
                        }/pdf/viewer.html?file=${encodeURIComponent(blobUrl)}`,
                        "_blank"
                    );
                })
                .catch((error) => {
                    console.error("Failed to load PDF:", error);
                });
        }
    };

    const subFileDownload = () => {
        setSubFilePopup(true);
    };
    const subFilePopupClose = () => {
        setSubFilePopup(false);
    };

    const scrollToTop = () => {
        animateScroll.scrollToTop({ duration: 0 });
    };
    const scrollToError = () => {
        setTimeout(() => {
            scroller.scrollTo("errorMsg", {
                smooth: true,
                offset: -100,
                duration: 1000,
            });
        }, 0.2);
    };

    const redirectToFormA = () => {
        dispatch(setCurrentStep("FormA"));
    };

    const redirectToApproverForm = () => {
        dispatch(updateMultiSubmitEditing(true));
        if (getIsApproverSaveForm(formId)) {
            dispatch(
                getApproverEditFormTempRequest(formId, formRef, status, "2")
            );
        }
        switch (status) {
            case 1:
                dispatch(setCurrentStep("FormA"));
                break;
            case 3:
                dispatch(setCurrentStep("FormB"));
                break;
            case 5:
                dispatch(setCurrentStep("FormC"));
                break;
            case 7:
                dispatch(setCurrentStep("FormD"));
                break;
            case 9:
                dispatch(setCurrentStep("FormE"));
                break;
        }
    };

    const checkApproverRoleFunc = () => {
        if (checkApproverRole.role1 === checkApproverRole.role2) {
            onFormEdit();
        } else {
            setApproveRolePopup(true);
        }
    };
    const closeApproverRolePup = () => {
        setApproveRolePopup(false);
    };

    console.log("isNotEmpty(onClear): ", isNotEmpty(onClear));
    console.log("isNotEmpty(onNext): ", isNotEmpty(onNext));
    useEffect(scrollToTop, []);
    useEffect(() => {
        if (requiredLogin && isEmpty(token)) {
            setOpenLogin(true);
        }
    }, []);
    const isApplicant = checkApplicant(currentWorkFlow, profile);
    const hasWithdrewButton = () => {
        // EE-7574 For Form 30, 52, 53, 54-56, 57, 58, 69, 70, 73, 74

        const flag = Constant?.withdrewForm?.some((item) => item == formId);

        if (
            formId === "Form098" &&
            flag &&
            (status == 0 || status == 5) &&
            isApplicant
        ) {
            return true;
        }
        // return and applicaton
        if (flag && status == 0 && isApplicant) {
            return true;
        } else {
            return false;
        }
    };
    const handleWithdraw = async () => {
        const formData = new FormData();
        formData.append("formRef", formRef);
        // // formData.append("msg", msg);
        const link = "withdraw";
        const option = {
            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/${link}`,
            method: "PUT",
            body: formData,
        };

        return await dispatch(send("APPROVAL_FLOW", option)).then((res) => {
            setOpenWithdrawnDialog(true);
            // window.location.reload();
            return res.json();
        });
    };

    function getZip() {
        const formNum = Number(formId.replace("Form", ""));
        const option = {
            url: `${Config.CONTENT_PATH}/attachment/getFormAllAttachmentZip/${formNum}/${formRef}`,
            method: "GET",
            header: {
                Accept: "application/zip",
            },
        };
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => res.blob())
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = `eformss_${referenceId}_${moment().format(
                    "MM_DD_YYYY[.zip]"
                )}`;
                aTag.click();
                URL.revokeObjectURL(result);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const downloadForm107Zip = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/form107/getAttachmentZipByPage`,
            method: "POST",
            body: JSON.stringify({
                formRef: formRef,
                pageNum: pageNum,
                attachmentIdList: currentPageFileIds,
            }),
            header: {
                Accept: "application/zip",
            },
        };
        let filename = `Form107${String(formRef).padStart(6, "0")}_Page${String(
            pageNum
        ).padStart(3, "0")}.zip`;
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => {
                const contentDisposition = res.headers.get(
                    "content-disposition"
                );
                if (contentDisposition) {
                    const [_, temp] = contentDisposition.split("filename=");
                    if (temp) {
                        filename = temp;
                    }
                }
                return res.blob();
            })
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = filename;
                aTag.click();
                URL.revokeObjectURL(result);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const downloadpdf = () => {
        const zipData = {};
        const formNum = Number(formId.replace("Form", ""));
        zipData[formNum] = [formRef];
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/zip`,
            method: "POST",
            body: JSON.stringify(zipData),
            header: {
                Accept: "application/pdf",
            },
        };
        let filename = `eformss_${moment().format("MM_DD_YYYY[.zip]")}`;
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => {
                const contentDisposition = res.headers.get(
                    "content-disposition"
                );
                if (contentDisposition) {
                    const [_, temp] = contentDisposition.split("filename=");
                    if (!temp) {
                        console.error("Filename is null or undefined");
                    } else {
                        filename = temp;
                    }
                }
                return res.blob();
            })
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = filename;
                aTag.click();
                URL.revokeObjectURL(result);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        // <ThemeProvider theme={theme}>
        <FormBox style={{ border: "0" }}>
            {formId === "Form101" && isApprovalStep && !disablePDF && (
                <Typography style={{ textAlign: "justify" }}>
                    {t(`${formId}.label.previewPDF`)}
                </Typography>
            )}
            <Box
                // display="flex"
                // justifyContent="flex-end"
                className="approvalBtnList"
            >
                {isApprovalStep && !disablePDF && (
                    <>
                        {isDownloadAttachmentButton && (
                            <Button
                                variant="contained"
                                classes={{ root: classes.backBtn }}
                                onClick={() => {
                                    getZip();
                                }}
                            >
                                {t("common.button.download")}
                            </Button>
                        )}
                        {formId === "Form107" && (
                            <Button
                                variant="contained"
                                classes={{ root: classes.backBtn }}
                                onClick={() => {
                                    getZip();
                                }}
                            >
                                download PDF
                            </Button>
                        )}
                        {/* Form107 不显示预览/下载按钮 */}
                        {formId !== "Form107" && (
                            <Button
                                variant="contained"
                                classes={{ root: classes.backBtn }}
                                onClick={() => {
                                    if (isObjectNotEmpty(replySlipOption)) {
                                        // for form14 only EBD have pdf option, others only shows fileA
                                        if (
                                            (userRole === "FO" &&
                                                formId === "Form014") ||
                                            (userRole === "FR" &&
                                                formId === "Form014") ||
                                            // for form98 case: divide part a-f and part g in pdf
                                            form98UseCase
                                        ) {
                                            subFileDownload();
                                        } else if (formId === "Form098") {
                                            onDownload("a");
                                        } else {
                                            onDownload();
                                        }
                                    } else {
                                        onDownload();
                                    }
                                    console.log(params.deadLine);
                                }}
                            >
                                {t("common.button.preview")}
                                {getIspreviewPDFTooltipForm(formId) &&
                                    status < 9 && (
                                        <CustomTooltip
                                            whiteIcon={true}
                                            title={t("common.toolTip.previewPDF")}
                                        />
                                    )}
                            </Button>
                        )}
                    </>
                )}
                {hasExitEditButton && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.backBtn }}
                        onClick={() => {
                            setExitEditPopup(true);
                            setOpenApprovalDialog(false);
                        }}
                    >
                        {t("common.button.exitEdit")}
                    </Button>
                )}
                {hasExitEditButton && getIsApproverSaveForm(formId) && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.submitBtn }}
                        onClick={() => setApproverSavePopup(true)}
                    >
                        {t("common.button.save")}
                    </Button>
                )}
                {hasBackButton && isFunction(onBack) && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.backBtn }}
                        onClick={() => {
                            if (currentStep !== "Confirmation") {
                                setBackPopup(true);
                            } else {
                                onBack();
                                scrollToTop();
                            }
                        }}
                    >
                        {t("common.button.back")}
                    </Button>
                )}
                {!disableSave && ((isFormFilling && isEmpty(initialStep)) || isSavedDraft) && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.submitBtn }}
                        onClick={() => setSavePopup(true)}
                    >
                        {t("common.button.save")}
                    </Button>
                )}
                {isFunction(onNext) &&
                    isFunction(handleSubmit) &&
                    isFunction(onError) && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.submitBtn }}
                            onClick={() => {
                                handleSubmit(
                                    handleNextAction,
                                    handleErrorAction
                                )();
                            }}
                        >
                            {t("common.button.next")}
                        </Button>
                    )}
                {finalSubmitStep &&
                    (isFormFilling || isSavedDraft) &&
                    !isApprovalStep &&
                    !isExceedingDeadline && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                if (isSavedDraft) {
                                    onFormSubmit();
                                } else if (isApplicantSigning) {
                                    setOpen(true);
                                } else {
                                    if (formId === "Form007") {
                                        setForm007OpenSubmittedDialog(true);
                                    } else {
                                        onFormSubmit();
                                    }
                                }
                            }}
                        >
                            {t("common.button.submit")}
                        </Button>
                    )}
                {hasWithdrewButton() && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.backBtn }}
                        onClick={() => {
                            // setAction("withdrew");
                            // setWithdrewOpen(true);
                            handleWithdraw();
                        }}
                    >
                        {t("common.button.withdrew")}
                    </Button>
                )}

                {hasEditButton &&
                    isNotEmpty(initialStep) &&
                    !form98SecApprover &&
                    !isExceedingDeadline && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                dispatch(setCurrentStep(initialStep));
                                if (getIsApproverSaveForm(formId)) {
                                    dispatch(
                                        getApproverEditFormTempRequest(
                                            formId,
                                            formRef,
                                            status,
                                            "1"
                                        )
                                    );
                                }
                            }}
                        >
                            {t("common.button.edit")}
                        </Button>
                    )}
                {hasReturnButton &&
                    !skipReturn &&
                    !isExceedingDeadline &&
                    !form090ExceedingDeadline &&
                    !form102EDBReviewerReceive && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                setAction("return");
                                setOpenApprovalDialog(true);
                            }}
                        >
                            {formId === "Form107" ? t("common.button.replyForUpdate") : t("common.button.reply")}
                        </Button>
                    )}
                {hasReturnButton &&
                    !skipReject &&
                    formId !== "Form008" &&
                    !form102EDBReviewerReceive && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                setAction("reject");
                                setOpenApprovalDialog(true);
                            }}
                        >
                            {formId === "Form107" ? t("common.button.inactivate") : t("common.button.reject")}
                        </Button>
                    )}
                {hasReturnButton &&
                    !skipReject &&
                    formId === "Form008" &&
                    status >= 3 && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                setAction("reject");
                                setOpenApprovalDialog(true);
                            }}
                        >
                            {t("common.button.reject")}
                        </Button>
                    )}
                {(isEdbApproval || form102EDBReviewerReceive) && (
                    <Button
                        variant="contained"
                        classes={{ root: classes.backBtn }}
                        onClick={() => {
                            onFormApproval({
                                act: form102EDBReviewerReceive
                                    ? `approve${layer}`
                                    : "review",
                            });
                        }}
                    >
                        {form102EDBReviewerApprove
                            ? t("common.button.102Approve")
                            : t("common.button.approve")}
                    </Button>
                )}
                {isSigning &&
                    !form102EDBReviewerReceive &&
                    !form090ExceedingDeadline && (
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                if (formId === "Form059") {
                                    const formList =
                                        fieldValues?.ApplicationInfo?.list?.[0];
                                    const otherThanOption3 = isObject(formList)
                                        ? Object.keys(formList)?.find(
                                              (key) =>
                                                  key !== "schoolChoiceTypeB" &&
                                                  formList?.[key]?.selected ===
                                                      true
                                          )
                                        : false;
                                    const role = uesrOrg?.role;
                                    if (otherThanOption3 && role !== "S") {
                                        setForm059OpenSubmittedDialog(true);
                                    } else {
                                        setOpen(true);
                                    }
                                } else {
                                    setOpen(true);
                                }
                            }}
                        >
                            {approvalSignText || t("common.button.sign")}
                        </Button>
                    )}
                {(formId === "Form101"
                    ? hasSubmitEditButton
                    : hasApproveButton || hasSubmitEditButton) &&
                    !isExceedingDeadline && (
                        // hasApproveButton: approval page submit
                        // hasSubmitEditButton: editing mode submit
                        <Button
                            variant="contained"
                            classes={{ root: classes.backBtn }}
                            onClick={() => {
                                // new multi layer method
                                console.log(
                                    "hasMultiSubmitLayer: ",
                                    hasMultiSubmitLayer
                                );
                                console.log(
                                    "hasApproveButton: ",
                                    hasApproveButton
                                );
                                if (
                                    hasMultiSubmitLayer &&
                                    hasApproveButton
                                    // !skipMultiSubmit
                                ) {
                                    setMultiSubmitPopup(true);
                                }
                                // new multi layer method
                                // when multi layer form part I submit edit
                                else if (
                                    hasMultiSubmitLayer &&
                                    getIsMultiSubmitEmpty(status, fieldValues)
                                ) {
                                    dispatch(setCurrentStep("Approval"));
                                } else if (checkApproverRole) {
                                    checkApproverRoleFunc();
                                } else {
                                    if (formId === "Form059") {
                                        const formList =
                                            fieldValues?.ApplicationInfo
                                                ?.list?.[0];
                                        const otherThanOption3 = isObject(
                                            formList
                                        )
                                            ? Object.keys(formList)?.find(
                                                  (key) =>
                                                      key !==
                                                          "schoolChoiceTypeB" &&
                                                      formList?.[key]
                                                          ?.selected === true
                                              )
                                            : false;
                                        const role = uesrOrg?.role;
                                        if (otherThanOption3 && role !== "S") {
                                            setForm059OpenSubmittedDialog(true);
                                        } else {
                                            onFormEdit();
                                        }
                                    } else if (formId === "Form102") {
                                        setForm102EditDialog(true);
                                    } else if (
                                        applicantCanWithdrawal === true
                                    ) {
                                        setOpen(true);
                                    } else {
                                        onFormEdit();
                                    }
                                }
                            }}
                        >
                            {hasApproveButton ||
                            isSubmitEditedButton ||
                            formId === "Form101"
                                ? approvalSubmitText ||
                                  t("common.button.submit")
                                : t("common.button.submitEdited")}
                        </Button>
                    )}

                {/* <AlertDialog
                    formOpen={savePopup}
                    content={t("common.save.popup.msg")}
                    closeButton={{
                        action: handleSaveClose,
                        label: t("common.save.popup.cancel"),
                    }}
                    confirmButton={{
                        action: handleSaveConfirm,
                        label: t("common.save.popup.confirm"),
                    }}
                /> */}

                <Dialog
                    open={savePopup}
                    onClose={handleSaveClose}
                    aria-labelledby="save-dialog-title"
                    aria-describedby="save-dialog-title"
                >
                    <DialogContent>
                        <DialogContentText id="save-dialog-description">
                            {t("common.save.popup.msg")}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleSaveClose}>
                            {t("common.save.popup.cancel")}
                        </Button>
                        <Button onClick={handleSaveNoRedirect}>
                            {t("common.save.popup.save")}
                        </Button>
                        <Button onClick={handleSaveConfirm}>
                            {t("common.save.popup.confirm")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <AlertDialog
                    formOpen={saveSuccessPopup}
                    content={t("common.save.successPopup.msg")}
                    confirmButton={{
                        action: () => navigate("/main"),
                        label: t("common.save.successPopup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={saveBeforeDownloadSuccessPopup}
                    content={t(
                        "common.save.saveBeforeDownloadSuccessPopup.msg"
                    )}
                    confirmButton={{
                        action: () => {
                            setSaveBeforeDownloadSuccessPopup(false);
                            onDownloadPDFBeforeSave();
                        },
                        label: t(
                            "common.save.saveBeforeDownloadSuccessPopup.confirm"
                        ),
                    }}
                />

                <AlertDialog
                    formOpen={backPopup}
                    content={t("common.save.backPopup.msg")}
                    confirmButton={{
                        action: () => {
                            onBack();
                            scrollToTop();
                        },
                        label: t("common.save.backPopup.confirm"),
                    }}
                    closeButton={{
                        action: () => setBackPopup(false),
                        label: t("common.save.backPopup.cancel"),
                    }}
                />

                <AlertDialog
                    formOpen={saveFailPopup}
                    content={t("common.save.failPopup.msg")}
                    confirmButton={{
                        action: () => setSaveFailPopup(false),
                        label: t("common.save.failPopup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={validFailPopup}
                    content={validMsg}
                    confirmButton={{
                        action: () => setValidFailPopup(false),
                        label: t("common.save.failPopup.confirm"),
                    }}
                />

                <Dialog
                    open={approverSavePopup}
                    onClose={handleApproverSaveClose}
                    aria-labelledby="save-dialog-title"
                    aria-describedby="save-dialog-title"
                >
                    <DialogContent>
                        <DialogContentText id="save-dialog-description">
                            {t("common.save.popup.msg")}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleApproverSaveClose}>
                            {t("common.save.popup.cancel")}
                        </Button>
                        <Button onClick={handleApproverSaveNoRedirect}>
                            {t("common.save.popup.save")}
                        </Button>
                        <Button onClick={handleApproverSaveConfirm}>
                            {t("common.save.popup.confirm")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <AlertDialog
                    formOpen={approverSaveSuccessPopup}
                    content={t("common.save.successPopup.msg")}
                    confirmButton={{
                        action: () => navigate("/main"),
                        label: t("common.save.successPopup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={approverSaveFailPopup}
                    content={t("common.save.failPopup.msg")}
                    confirmButton={{
                        action: () => setApproverSaveFailPopup(false),
                        label: t("common.save.failPopup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={exitEditPopup}
                    content={
                        formId === "Form101"
                            ? t("Form101.editDialog.msg")
                            : t("common.approval.popup.msg")
                    }
                    closeButton={{
                        action: handleExitClose,
                        label: t("common.approval.popup.cancel"),
                    }}
                    confirmButton={{
                        action: handleExitConfirm,
                        label: t("common.approval.popup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={multiSubmitPopup}
                    content={
                        formId === "Form028"
                            ? t(`${formId}.submittedDialog.multiLayerSubmitMsg`)
                            : formId === "Form097" && status === 3
                            ? t(`${formId}.submittedDialog.multiLayerSubmitMsg`)
                            : formId === "Form029"
                            ? t(`${formId}.submittedDialog.multiLayerSubmitMsg`)
                            : formId === "Form098"
                            ? t(`${formId}.submittedDialog.multiLayerSubmitMsg`)
                            : t("common.multiLayerSubmit.popup.msg")
                    }
                    closeButton={{
                        action: handleMultiSubmitClose,
                        label: t("common.multiLayerSubmit.popup.cancel"),
                    }}
                    confirmButton={{
                        // action: redirectToFormA,
                        action: redirectToApproverForm,
                        label: t("common.multiLayerSubmit.popup.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={approveRolePopup}
                    content={t("common.approval.approverRole")}
                    confirmButton={{
                        action: closeApproverRolePup,
                        label: t("common.confirm"),
                    }}
                />

                <AlertDialog
                    formOpen={approverEditLoadForm}
                    content={t("common.loadForm.popup.msg")}
                    confirmButton={{
                        action: () => {
                            dispatch(
                                setFullFieldValues(approverEditFieldValues)
                            );
                            dispatch(
                                setCurrentStepWithRerender(
                                    approverEditCurrentStep
                                )
                            );
                            dispatch(toggleApproverEditLoadFormPopup());
                            i18n.changeLanguage(approverEditFormLanguage);
                        },
                        label: t("common.loadForm.popup.confirm"),
                    }}
                    closeButton={{
                        action: () =>
                            dispatch(toggleApproverEditLoadFormPopup()),
                        label: t("common.loadForm.popup.cancel"),
                    }}
                />
                <SigningDialog
                    formOpen={open}
                    onSign={onSign}
                    onClose={() => {
                        setOpen(false);
                        if (applicantCanWithdrawal === true) {
                            setOpenSubmittedDialog(true);
                        }
                    }}
                />
                <SubmittedDialog
                    formOpen={openSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setOpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <WithdrawnDialog
                    formOpen={openWithdrawnDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setOpenWithdrawnDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form016SubmittedDialog
                    formOpen={form016OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm016OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                />
                <Form017SubmittedDialog
                    formOpen={form017OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm017OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                />
                <Form028SubmittedDialog
                    formOpen={form028OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm028OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form029SubmittedDialog
                    formOpen={form029OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm029OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form040SubmittedDialog
                    formOpen={form040OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm040OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form045SubmittedDialog
                    formOpen={form045OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm045OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form059SubmittedDialog
                    formOpen={form059OpenSubmittedDialog}
                    onConfirm={() => {
                        setForm059OpenSubmittedDialog(false);
                    }}
                />
                <Form075SubmittedDialog
                    formOpen={form075OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm075OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form091SubmittedDialog
                    formOpen={form091OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm091OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form101SubmittedDialog
                    formOpen={form101OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm101OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form101SubmittedTimeOutDialog
                    formOpen={form101SubmittedTimeOutDialog}
                    onConfirm={() => {
                        navigate("/main");
                    }}
                />
                <Form101EditDialog
                    formOpen={form101OpenEditDialog}
                    onConfirm={() => {
                        window.location.reload();
                    }}
                />
                <Form102SubmittedDialog
                    formOpen={form102OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm102OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form106SubmittedDialog
                    formOpen={form106OpenSubmittedDialog}
                    onConfirm={() => {
                        if (isEmpty(initialStep)) {
                            navigate(`/approval/${formId}/${referenceId}`);
                            setForm106OpenSubmittedDialog(false);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form107SubmittedDialog
                    formOpen={form107OpenSubmittedDialog}
                    onConfirm={() => {
                    
                        
                        if (isEmpty(initialStep) || window.location.pathname.includes('draft/Form107')) {
                            // For draft mode submission, navigate to approval page
                            setForm107OpenSubmittedDialog(false);
                            navigate(`/approval/${formId}/${referenceId}`);
                        } else {
                            window.location.reload();
                        }
                    }}
                    referenceNumber={referenceId}
                />
                <Form102EditDialog
                    formOpen={form102EditDialog}
                    onConfirm={() => {
                        setForm102EditDialog(false);
                        onFormEdit();
                    }}
                    onClose={() => {
                        setForm102EditDialog(false);
                    }}
                    referenceNumber={referenceId}
                />
                <Form007SubmittedDialog
                    formOpen={form007OpenSubmittedDialog}
                    onConfirm={() => {
                        setForm007OpenSubmittedDialog(false);
                        onFormSubmit();
                    }}
                    onClose={() => {
                        setForm007OpenSubmittedDialog(false);
                    }}
                    referenceNumber={referenceId}
                />
                <Form098EditDialog
                    formOpen={form098OpenEditDialog}
                    onConfirm={() => {
                        window.location.reload();
                    }}
                />
                <ApprovalDialog
                    formOpen={openApprovalDialog}
                    onSubmit={onFormApproval}
                    onClose={() => setOpenApprovalDialog(false)}
                    action={action}
                />

                {handleSubmit && requiredLogin && (
                    <LoginDialog
                        formOpen={openLogin}
                        onLogin={() => {
                            setOpenLogin(false);
                            handleSubmit(
                                (formData) => {
                                    console.log("formData", formData);
                                    onNext(formData);
                                    scrollToError();
                                },
                                (errors) => {
                                    handleErrorAction(errors, true);
                                }
                            )();
                        }}
                        onClose={() => setOpenLogin(false)}
                    />
                )}

                <SubFileSelectDialog
                    formOpen={subFilePopup}
                    optionList={replySlipOption}
                    onDownload={(index) => onDownload(index)}
                    reset={subFilePopupClose}
                    handleOnClose={subFilePopupClose}
                />
            </Box>
        </FormBox>
        // </ThemeProvider>
    );
}
